import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import CancelModal from "../../../../shared/components/CancelModal";
import { WarningProductModal } from "../../../../configs/warningProductModal";
import { AddOn } from "../../../../data/entities";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";

interface TitleProps {
    title: string;
    data?: AddOn;
    setValidated: (validate: boolean) => void;
    onSubmit: Function;
    isLoading?: boolean;
}

const Title = ({ title, setValidated, data, onSubmit, isLoading = false }: TitleProps) => {
    const navigate = useNavigate();
    const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const titleActions: TitleAction[] = [
        {
            title: "Huỷ bỏ",
            onClick: () => setIsOpenCancelModal(true),
        },
        {
            title: "Lưu dịch vụ",
            variant: "contained",
            isLoading,
            onClick: () => {
                if (isLoading) return;
                setValidated(true);
                onSubmit();
            },
        },
    ];

    const getTitleActions = () => {
        switch (role) {
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
            case ROLE.DELIVERER:
                return [];
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.FACTORY_STAFF:
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return titleActions;
            default:
                return titleActions;
        }
    };

    return (
        <>
            <TitleRow title={title} actions={getTitleActions()} />
            {isOpenCancelModal && (
                <CancelModal
                    open={isOpenCancelModal}
                    title={WarningProductModal.title}
                    contentText={WarningProductModal.context}
                    handleConfirm={() => navigate("/addons/")}
                    handleClose={() => setIsOpenCancelModal(false)}
                />
            )}
        </>
    );
};

export default Title;
